/**
 * The sign-in form's answers (./MasukRoute): `masuk` resolves with one, and a failure it
 * was not told about (a worker that refused, a storage error) becomes `galat` instead of a
 * form left waiting; each failure has its sentence under the fields.
 */
import { uiStrings as ui } from '@satu/shared'
import type { MasukHasil } from '../../auth/session'

export type HasilMasukLayar = MasukHasil | { ok: false; alasan: 'galat' }

export async function masukAman(masuk: () => Promise<MasukHasil>): Promise<HasilMasukLayar> {
  try {
    return await masuk()
  } catch {
    return { ok: false, alasan: 'galat' }
  }
}

/** The sentence under the fields; `akunLain` is the "Lupa PIN?" variant's own sentence. */
export function teksGagalMasuk(
  alasan: 'tidak_cocok' | 'offline' | 'akun_lain' | 'galat' | 'kedaluwarsa',
  akunLain: string | null,
): string {
  switch (alasan) {
    case 'offline':
      return ui.masuk.offline
    // A sign-in that waited for an account step and was lost meanwhile: start again.
    case 'kedaluwarsa':
    case 'galat':
      return ui.masuk.belumBerhasil
    case 'akun_lain':
      return akunLain ?? ui.masuk.gagal
    case 'tidak_cocok':
      return ui.masuk.gagal
  }
}
